import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';



type EducationFormSubmit = {
    startDate: string;
    endDate?: string;
    fieldOfStudy: string;
    institution: string;
    degree: string;
}

type FormProps = {
    id: string,
    onUpdate: any
    educationDetails?: any
}

export const EducationForm = ({ id, onUpdate, educationDetails }: FormProps) => {
    const validationSchema = Yup.object().shape({
        startDate: Yup.string()
            .required('Start Date is required'),
        institution: Yup.string()
            .required('Institution is required'),
        fieldOfStudy: Yup.string()
            .required('Field of Study is required'),
        degree: Yup.string()
            .required('Degree is required'),
    });
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting }
    } = useForm<EducationFormSubmit>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            startDate: educationDetails?.education?.startDate,
            endDate: educationDetails?.education?.endDate,
            fieldOfStudy: educationDetails?.education?.fieldOfStudy,
            institution: educationDetails?.education?.institution,
            degree: educationDetails?.education?.degree,
        }
    });

    const resetForm = () => {
        reset();
    };

    const onSubmit = async (data: EducationFormSubmit) => {
        const education = {
            startDate: data['startDate'],
            endDate: data['endDate'],
            institution: data['institution'],
            degree: data['degree'],
            fieldOfStudy: data['fieldOfStudy'],
        };


        if (educationDetails !== undefined) {
            onUpdate(id, { index: educationDetails?.index, education }, "edit")
        } else {
            onUpdate(id, education, "new")

        }
        resetForm()



    };



    return (
        <div className="profile-add">
            <div className="row">
                <div className="col-md-10 offset-sm-1">
                    <h1 className="text-lg font-bold underline">Education</h1><br />
                    <form>
                        <div className="form-row mb-2">
                            <div className="flex flex-col">
                                <label className="text-base font-bold">Degree :</label>
                                <input type="text" {...register('degree')} className={`text-base border-black border  border-solid rounded-sm pl-1 ${errors.degree ? 'is-invalid' : ''}`} name="degree" />
                                <div className="invalid-feedback">{errors.degree?.message}</div>
                            </div>
                        </div>
                        <div className="form-row mb-2">
                            <div className="flex flex-col">
                                <label className="text-base font-bold">Institution :</label>
                                <input type="text" {...register('institution')} className={`text-base border-black border  border-solid rounded-sm pl-1 ${errors.institution ? 'is-invalid' : ''}`} name="institution" />
                                <div className="invalid-feedback">{errors.institution?.message}</div>
                            </div>
                        </div>
                        <div className="form-row mb-2">
                            <div className="flex flex-col">
                                <label className="text-base font-bold">Field of Study:</label>
                                <input type="text" {...register('fieldOfStudy')} className={`text-base border-black border  border-solid rounded-sm pl-1 ${errors.fieldOfStudy ? 'is-invalid' : ''}`} name="fieldOfStudy" />
                                <div className="invalid-feedback">{errors.fieldOfStudy?.message}</div>
                            </div>
                        </div>
                        <div className="form-row mb-2">
                            <div className="flex flex-col mb-2">
                                <label className="text-base font-bold" htmlFor="date" >Start Date</label>
                                <div className="input-group date" id="datepicker">
                                    <input type="date" {...register('startDate')} className={` ${errors.startDate ? 'is-invalid' : ''}`} id="date" />
                                    <div className="invalid-feedback">{errors.startDate?.message}</div>
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <label className="text-base font-bold" htmlFor="date" >End Date</label>
                                <div className="input-group date" id="datepicker">
                                    <input type="date" {...register('endDate')} className="form-control" id="date" />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="col-md-12 text-center">
                                <button type="submit" onClick={handleSubmit(onSubmit)} className="btn btn-primary btn-save">Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}